{
  "DownloadReportDialog": {
    "title": "下载报告",
    "fieldScope": "工作区",
    "selectScope": "选择工作区",
    "wholeOrganization": "所有工作区 — 整个组织",
    "download": "下载",
    "downloadFailed": "无法下载报告，请重试。"
  },
  "entityTypes": {
    "contact": "资源",
    "callout": "征集",
    "shortlist": "候选名单",
    "callsheet": "通告单",
    "production": "制作",
    "booking": "预订"
  },
  "ReportTemplateColumns": {
    "name": "名称",
    "description": "描述",
    "type": "类型"
  },
  "ReportTemplatesPage": {
    "title": "报告模板",
    "newTemplate": "新建报告模板",
    "entityNameSingular": "报告模板",
    "rowActions": "模板操作",
    "editTemplate": "编辑模板",
    "viewTemplate": "查看模板",
    "downloadReport": "下载报告",
    "downloadReportInDialog": "下载报告…",
    "archiveTemplate": "归档模板",
    "unarchiveTemplate": "恢复模板",
    "archiveSuccess": "报告模板已归档",
    "unarchiveSuccess": "报告模板已恢复",
    "emptyActive": "没有报告模板",
    "emptyArchived": "没有已归档的报告模板",
    "emptyMessage": "数据导出可将数据导出为 CSV 文件"
  },
  "WorkspaceReportingPage": {
    "title": "报告",
    "downloadReport": "下载报告",
    "settingsLabel": "配置报告模板",
    "settingsInOrganization": "在此组织",
    "workspaceFailed": "无法加载此工作区，因此无法下载其报告。"
  },
  "ReportTemplateEditor": {
    "titleCreate": "新建报告模板",
    "titleEdit": "编辑报告模板",
    "titleView": "报告模板",
    "create": "创建模板",
    "save": "保存更改",
    "close": "关闭",
    "name": "名称",
    "namePlaceholder": "例如：每周人才名单",
    "nameRequired": "请输入名称",
    "description": "描述",
    "descriptionPlaceholder": "报告的用途",
    "reportOn": "报告对象",
    "typeLabel": {
      "contact": "资源类型",
      "booking": "预订类型",
      "production": "制作类型"
    },
    "typeAll": {
      "contact": "所有资源类型",
      "booking": "所有预订类型",
      "production": "所有制作类型"
    },
    "archivedType": "{{name}}（已归档）",
    "filters": "筛选条件",
    "filtersHint": "报告包含哪些记录。下载时所在的工作区会另外加上。",
    "dateFields": {
      "created_at": "创建时间",
      "booking_date": "预订日期",
      "production_date": "制作日期",
      "callsheet_date": "通告单日期"
    },
    "dateGroup": "日期",
    "booked": "已预订",
    "columns": "列",
    "columnsHint": "文件的列，按此顺序。",
    "columnsRequired": "请至少选择一列",
    "idColumn": "ID",
    "guidColumn": "GUID",
    "relativeDates": {
      "TODAY": "今天",
      "YESTERDAY": "昨天",
      "TOMORROW": "明天",
      "LAST_7": "最近 7 天",
      "LAST_30": "最近 30 天",
      "NEXT_7": "未来 7 天",
      "NEXT_30": "未来 30 天",
      "LAST_WEEK": "上周",
      "NEXT_WEEK": "下周",
      "LAST_MONTH": "上个月",
      "NEXT_MONTH": "下个月",
      "QUARTER": "本季度",
      "LAST_QUARTER": "上季度",
      "NEXT_QUARTER": "下季度"
    }
  },
  "ReportFile": {
    "ready": "报告已准备好。",
    "open": "打开报告"
  }
}
